<template>
  <v-list-item class="pr-2">
    <v-list-item-content @click="state = ! state">
      <v-list-item-title v-text="label" />
    </v-list-item-content>
    <v-list-item-action>
      <v-switch v-model="state" inset color="primary" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
  export default {
    props: {
      value: {
        required: false,
        type: Boolean,
        default: false,
      },
      label: {
        required: false,
        type: String,
        default: '',
      },
    },

    computed: {
      state: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        },
      },
    },
  }
</script>
